import React, { useEffect, useState } from 'react';
import styled from 'styled-components';

const OverlayWrapper = styled.div`
  display: ${props => (props.showOverlay ? 'flex' : 'none')};
  position: fixed;
  background: ${props => props.backgroundColour};
  z-index: 100;
  left: ${props => props.left}px;
  top: ${props => props.top}px;
  height: ${props => props.height}px;
  width: ${props => props.width}px;
  flex-direction: column;
  justify-content: center;
`;

const Overlay = ({
  showOverlay,
  children,
  overlayDiv,
  headerDiv,
  backgroundColour,
  opacityForDiv
}) => {
  const [top, setTop] = useState();
  const [left, setLeft] = useState();
  const [width, setWidth] = useState();
  const [height, setHeight] = useState();

  useEffect(() => {
    const handleResize = () => {
      const headHeight =
        !headerDiv || !headerDiv.current ? 0 : headerDiv.current.getBoundingClientRect().height;

      setTop(overlayDiv.current.getBoundingClientRect().top + headHeight);
      setLeft(overlayDiv.current.getBoundingClientRect().left);
      setWidth(overlayDiv.current.getBoundingClientRect().width);
      setHeight(overlayDiv.current.getBoundingClientRect().height - headHeight);
    };
    handleResize();
    window.addEventListener('resize', handleResize);
  }, []);

  if (!overlayDiv || !overlayDiv.current) return <div>&nbsp;</div>;

  // set opacity of parent
  if (!headerDiv || !overlayDiv.current) {
    overlayDiv.current.style.opacity = opacityForDiv;
  } else {
    overlayDiv.current.childNodes.forEach(child => {
      if (child !== headerDiv.current) {
        const highZIndex = child.style.zIndex && Number(child.style.zIndex) > 1000;
        child.style.opacity = showOverlay && !highZIndex ? opacityForDiv : 1.0;
      }
    });
  }

  return (
    <OverlayWrapper
      backgroundColour={backgroundColour}
      left={left}
      top={top}
      width={width}
      height={height}
      showOverlay={showOverlay}
    >
      {children}
    </OverlayWrapper>
  );
};

export default Overlay;



// WEBPACK FOOTER //
// ./src/components/ChatPanel/Overlay/index.js